import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogBody,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../ui/dialog";
import Button from "../../../button-v1";
import styles from "./styles.module.css";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePatientNote } from "../../../../services/patient/details";
import { toast } from "react-hot-toast";

const EditNoteDialog = ({
  isOpen,
  onClose,
  note,
  onSave,
  showNoteTypeSelector = false,
}) => {
  const accountId = sessionStorage.getItem("acc_id");
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id;
  const patientId = sessionStorage.getItem("_pt_id");
  const queryClient = useQueryClient();
  const [editedNote, setEditedNote] = useState("");
  const [selectedNoteType, setSelectedNoteType] = useState(
    note?.note_type || "rpm_note"
  );

  const updateMutation = useMutation(
    () =>
      updatePatientNote(
        note.id,
        editedNote,
        patientId,
        locationId,
        selectedNoteType
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["patient-notes"]);
        toast.success("Note updated successfully");
      },
      onError: (error) => {
        toast.error("Could not update note");
      },
    }
  );

  const handleSave = () => {
    updateMutation.mutate();
  };

  useEffect(() => {
    if (note?.note_text) {
      setEditedNote(note.note_text);
      setSelectedNoteType(note.note_type || "rpm_note");
    }
  }, [note]);

  useEffect(() => {
    if (updateMutation.isSuccess) {
      onClose();
    }
  }, [updateMutation.isSuccess]);

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Note</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className={styles.content}>
            {showNoteTypeSelector && (
              <div className={styles.noteTypeSelector}>
                <Button
                  variant={
                    selectedNoteType === "rpm_note" ? "primary" : "normal"
                  }
                  size="small"
                  onClick={() => setSelectedNoteType("rpm_note")}
                >
                  RPM Note
                </Button>
                <Button
                  variant={
                    selectedNoteType === "ccm_note" ? "primary" : "normal"
                  }
                  size="small"
                  onClick={() => setSelectedNoteType("ccm_note")}
                >
                  CCM Note
                </Button>
              </div>
            )}
            <textarea
              value={editedNote}
              onChange={(e) => setEditedNote(e.target.value)}
              className={styles.textarea}
              placeholder="Enter your note here..."
              autoFocus
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="normal" size="default" onClick={onClose}>
            Cancel
          </Button>
          <Button
            loading={updateMutation.isLoading}
            variant="primary"
            size="default"
            onClick={handleSave}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditNoteDialog;
